window.contactUs = function(){
    let formValues = $('#contact_us_form').serialize();
    $('#contact_us_modal .error-text').removeClass('d-block');
    $('#contact_us_modal .error-text').addClass('d-none');
    $('#contact_us_modal #loading_spinner').show();
    $('#contact_us_modal .submit_form').hide();
    $('#contact_us_modal #success').html('').hide();

    setTimeout(function() {
        axios.post(routes.WebContactUs, formValues).then(function(response){                
            $('#contact_us_modal #contact_us_form').remove();
            $('#contact_us_modal .modal-footer').remove();            
            $('#contact_us_modal .modal-body').append(`<span style="padding: 20px;display: flex;">${translations.Contact_us_success_message}</span>`);
        }).catch(function(errors){  
            $('#contact_us_modal #loading_spinner').hide();
            $('#contact_us_modal .submit_form').show();                               
            if(errors.response.status == 422){
                $.each(errors.response.data.errors, function (className, error) { 
                    $(`#contact_us_modal .${className}`).text(error).addClass('d-block');
                });             
            } else{     
                $('#contact_us_modal #success').html(translations.Error).show();              
            }           
        }); 
    }, 1000);    
}